import React from "react";
export const DocumentContext = React.createContext({});
